import { useGetUnauthenticatedFeaturesQuery } from "@/pages/Private/redux/feature/feature.api";

export const useIsFeatureActiveUnauthenticated = (featureName: string): boolean | undefined => {
	const { data: features } = useGetUnauthenticatedFeaturesQuery();
	const feature = features?.find((f) => f.feature === featureName);

	return feature ? feature.active : undefined;
};
